<template src="./Index.html"></template>

<script>
import AddView from "./actions/Add";
//import EditView from "./actions/Edit";
import DetailsView from "./details/Details";

export default {
    components: {
        AddView,
        //EditView,
        DetailsView,
    },
        created() {
            this.getAll();

        this.$store.dispatch("lookups/getLookups");
        this.$store.dispatch("lookups/getAppointmentTypes");
    },
    computed: {
        administrationTypes() {
            return  [
                {value:0 , label:"الكل"},
                 ...this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.AdministrationTypes) 
                ]             
        }, 
         administrations() {
            return [
                {value:0 , label:"الكل"},
                ...this.$store.state.lookups.administrations        
            ]
        },
        departments() {
            return [
                {value:0 , label:"الكل"},
                ...this.$store.state.lookups.departments        
            ]
        },
        directorsAppointments() {
            return this.$store.state.directorsAppointments.directorsAppointments;
        },
        appointmentTypes() {
            return  [
                {value:0 , label:"الكل"},
                ...this.$store.state.lookups.appointmentTypes
        ]
           // return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.AppointmentTypes)            
        },
        units() {
            return [
                {value:0 , label:"الكل"},
                ...this.$store.state.lookups.units        
            ]
        },
        pageCount() {
            return Math.ceil(
                this.$store.state.directorsAppointments.totalItems / this.filters.pageSize
            );
        },
    },
    data() {
        return {
            permissions: this.$empOperationsPermissions.directorAppointmentPermissions,

            items: [
                {
                    text: "تعيينات المدراء ",
                },
                // {
                //     text: "قائمة التعيينات",
                // },
            ],
            totalItems: 0,
            subtitle: "قائمة التعيينات",
            dialog: false,
            dialogType: null,
            dialogMessage: "",
            itemId: 0,
            view: 0,
            filters: {
                page: 1,
                pageSize: 10,
                appointmentTypeId: 0,
                administrationTypeId: 0,
                administrationId: null,
                departmentId: null,
            },
            headers: [
                {
                    text: "نوع التعيين",
                    value: "appointmentType",
                    sortable: false,
                    align: "start",
                },                {
                    text: "الاسم",
                    value: "name",
                    sortable: false,
                    align: "start",
                },
                // {
                //     text: "القسم ",
                //     value: "department",
                //     sortable: false,
                //     align: "start",
                // },
                {
                    text: "اسم المدير",
                    value: "manager",
                    sortable: false,
                    align: "start",
                },
                 { text: "مسجل بواسطة", value: "createdBy", sortable: false },
                { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
                { text: "الحالة", value: "status", sortable: false },
                {
                    text: "الإجراءات",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
        };
    },
        methods: {
            changeAdministration() {
            this.filters.departmentId = null;
            this.filters.unitId = null;
            if (this.filters.administrationTypeId != 1002) {
                this.$store.dispatch("lookups/getDepartments", this.filters.administrationId);
            }
            else {
                this.$store.dispatch("lookups/getUnitsById", {
                    typeId: 1,
                    id: this.filters.administrationId,
                });

            }
            this.getAll();

        },
        changeDepartment() {
            this.filters.unitId = null;
            this.$store.dispatch("lookups/getUnitsById", {
                typeId: 2,
                id: this.filters.departmentId,
            });
            this.getAll();

        },
            // getDepartments() {
            //     this.$store.dispatch("lookups/getDepartments", this.filters.administrationId);
            //     this.getAll();
            // },
        changeType(){
            this.filters.administrationId = null;
            this.filters.departmentId = null;
            this.filters.unitId = null;
            this.$store.dispatch("lookups/getAdministrationsByType", this.filters.administrationTypeId);
            this.getAll();
            },
            changeAppointmentType() {
                this.filters.administrationId = null;
                this.filters.administrationTypeId = null;
                this.filters.departmentId = null;
                this.filters.unitId = null;

            },
        getAll(page) {
            this.filters.page = page || 1;
            this.$store.dispatch("directorsAppointments/getAll", this.filters);
        },
        addItem() {
            this.view = 1;
            this.items.push({ text: "إضافة تعيين" });

        },
        //editItem(item) {
        //    this.itemId = item.departmentId;
        //    this.view = 2;
        //    this.items.push({ text: "تعديل تعيين" });

        //},
        showDetails(item) {
            this.itemId = item.directorAppointmentId;
            this.view = 3;
            this.items.push({ text: "عرض التفاصيل" });

        },
        showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف اجراء التعيين";
          break; 
             case "cancel":
          this.dialogMessage = "هل انت متأكد من رغبتك رفض اجراء التعيين";
          break;
        case "approval":
          this.dialogMessage = "هل انت متأكد من رغبتك اعتماد اجراء التعيين";
          break;
      }
      this.dialogType = type;
      this.itemId = item.directorAppointmentId;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`directorsAppointments/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
        back() {
            this.view = 0;
            this.items = [
                {
                    text: "تعيينات المدراء ",
                },
                // {
                //     text: "قائمة التعيينات",
                // },
            ];
        },
        reload() {
            this.filters.appointmentTypeId = 0;
            this.filters.departmentId = null;
            this.filters.administrationTypeId = 0;
            this.filters.administrationId = null;
            this.filters.unitId = null;
            this.getAll(1);
            this.back();
        },

        download() {
            let filters = {
                appointmentTypeId: this.filters.appointmentTypeId,
                administrationTypeId: this.filters.administrationTypeId,
                administrationId: this.filters.administrationId,
                departmentId: this.filters.departmentId,
            };

            const paramsString = Object.entries(filters)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            window.open(`/api/directorsAppointments/excel?${paramsString}`, "_blank");
        },
    },
};
</script>
